const cashierModel = {
  state: {
    internalId: "",
    gateways: [],
    cryptoFirstTimeWithdrawal: false,
  },
  reducers: {
    /**
     * Updates the `cryptoFirstTimeWithdrawal` property in the state.
     *
     * @param state - The current state object.
     * @param payload - The new value for the `cryptoFirstTimeWithdrawal` property.
     * @returns The updated state object with the new `cryptoFirstTimeWithdrawal` value.
     */
    setCryptoFirstTimeWithdrawal: (
      state: Record<string, any>,
      payload: boolean
    ) => {
      return { ...state, cryptoFirstTimeWithdrawal: payload };
    },
    set: (state: Record<string, any>, payload: Record<string, any>): any => {
      return { ...state, ...payload };
    },
    updateGateways: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, gateways: payload };
    },
  },
  effects: {},
};
export default cashierModel;
